import { Map } from "@vis.gl/react-google-maps";
import { CSSProperties } from "react";

import { ELITKLINIK_COORDS } from "@/constants";

const MapComponent = ({
    children,
    style,
    defaultCenter,
    defaultZoom,
    fixedCenter,
}: {
    children?: React.ReactNode | null;
    style?: CSSProperties;
    defaultCenter?: { lat: number; lng: number };
    defaultZoom?: number;
    fixedCenter?: boolean;
}) => {
    return (
        <Map
            style={style || { width: "100vw", height: "100vh" }}
            defaultCenter={defaultCenter || ELITKLINIK_COORDS}
            defaultZoom={defaultZoom || 10.5}
            defaultTilt={50}
            // mapId={"2635966e05b3c0d6"}
            mapId={"49ae42fed52588c3"}
            disableDoubleClickZoom={true}
            disableDefaultUI={true}
            clickableIcons={false}
            reuseMaps={true}
            center={fixedCenter ? defaultCenter : undefined}
            zoom={fixedCenter ? defaultZoom || 10.5 : undefined}
            tilt={fixedCenter ? 50 : undefined}
            controlled={fixedCenter}
        >
            {children}
        </Map>
    );
};

export default MapComponent;
